import React, { useState } from 'react'
import { IoAlertCircleOutline } from 'react-icons/io5'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import axios from 'axios'
import Modal from 'react-modal'
import DatosDelVehiculo from './DatosDelVehiculo'
import TablaDocumentos from './TablaDocumentos'
import formatDate from '../../../formatDate'
import PasajeroNiku from '../../../assets/img/pasajero_niku.png'
Modal.setAppElement('#root')

export default function BotonDetalles({ rowData }) {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [driverDetails, setDriverDetails] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const modalMarginStyle =
    window.innerWidth > 1280
      ? { marginLeft: 'calc((100% - 20.5rem) / 3)', marginTop: '3rem' }
      : { margin: '0 auto', marginTop: '7.5rem' }

  const openModal = async () => {
    setModalIsOpen(true)
    setIsLoading(true)
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_DRIVERs_ID}/${rowData.driver_id}`,
        {
          headers: {
            'x-hasura-admin-secret': process.env.REACT_APP_API_KEY,
          },
        }
      )
      setDriverDetails(response.data.drivers[0])
    } catch (error) {
      console.error('Error fetching driver details:', error)
    }

    setIsLoading(false)
  }

  const closeModal = () => {
    setModalIsOpen(false)
  }

  return (
    <div className="text-center">
      <button
        className="bg-BlueD text-white p-1 rounded-l-full hover:bg-greenE hover:scale-150"
        onClick={openModal}
      >
        <IoAlertCircleOutline className="text-2xl" />
      </button>
      <Modal
        className={`bg-gray-100 flex flex-col rounded-xl border-4 w-modal h-modalAjuste border-orange-500`}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        style={{
          overlay: {
            backgroundColor: '#00000099',
            overflow: 'auto',
          },
          content: {
            overflowY: 'auto',
            overflowX: 'hidden',
            ...modalMarginStyle,
          },
        }}
      >
        <div className="flex justify-between">
          <button
            className="p-1 ml-auto"
            onClick={closeModal}
          >
            <AiOutlineCloseCircle className="text-orange-500 hover:bg-orange-600 hover:text-white rounded-full text-4xl" />
          </button>
        </div>
        <h2 className="text-2xl text-center font-bold">
          {isLoading
            ? 'Cargando detalles del conductor...'
            : driverDetails
              ? (driverDetails.name ? driverDetails.name : '').toUpperCase() +
              ' ' +
              (driverDetails.last_name ? driverDetails.last_name : '').toUpperCase()
              : 'Detalles no disponibles'}
        </h2>
        <div className="flex justify-center items-center w-full p-4 ml-4">
          <div className="grid semi:grid-cols-3 gap-4 ">
            <div className="semi:col-span-1 h-full flex items-center justify-center">
              <img
                loading="lazy"
                className="h-box "
                src={
                  isLoading
                    ? 'URL_de_imagen_de_carga'
                    : driverDetails && driverDetails.img
                      ? driverDetails.img
                      : PasajeroNiku
                }
                alt="Conductor sin imagen"
                style={{
                  borderRadius: '80%',
                  width: '300px',
                  height: '300px',
                  objectFit: 'cover',
                }}
              />
            </div>
            <div className="semi:col-span-2">
              <h2 className="text-xl mb-7">
                <strong>ID:</strong>{' '}
                <span>
                  {isLoading
                    ? ''
                    : driverDetails
                      ? driverDetails.id
                      : 'Detalles no disponibles'}
                </span>
              </h2>
              <h2 className="text-xl mb-7">
                <strong>Correo:</strong>{' '}
                <span>
                  {isLoading
                    ? ''
                    : driverDetails
                      ? driverDetails.email
                      : 'Detalles no disponibles'}
                </span>
              </h2>
              <h2 className="text-xl mb-7">
                <strong>Tel:</strong>{' '}
                <span>
                  {isLoading
                    ? ''
                    : driverDetails
                      ? driverDetails.tel
                      : 'Detalles no disponibles'}
                </span>
              </h2>
              <h2 className="text-xl mb-7">
                <strong>Fecha de aprobacion:</strong>{' '}
                <span>
                  {isLoading
                    ? ''
                    : driverDetails
                      ? formatDate(driverDetails.fechaRegistro)
                      : 'Detalles no disponibles'}
                </span>
              </h2>
              <h2 className="text-xl mb-7">
                <strong>Fecha de registro:</strong>{' '}
                <span>
                  {isLoading
                    ? ''
                    : driverDetails
                      ? formatDate(driverDetails.fechaRegistro)
                      : 'Detalles no disponibles'}
                </span>
              </h2>
              <h2 className="text-xl mb-7">
                <strong>Lugar:</strong>{' '}
                <span>
                  {isLoading
                    ? ''
                    : driverDetails
                      ? driverDetails.state
                      : 'Detalles no disponibles'}
                </span>
              </h2>
              <h2 className="text-xl mb-7">
                <strong>Estatus:</strong>{' '}
                <span>
                  {isLoading
                    ? ''
                    : driverDetails
                      ? driverDetails.status
                      : 'Detalles no disponibles'}
                </span>
              </h2>
            </div>
            <h2 className="text-xl">
              <strong>Datos Fiscales:</strong>{' '}
              <span>
                {isLoading
                  ? ''
                  : driverDetails
                    ? driverDetails.datosFiscales
                    : 'Detalles no disponibles'}
              </span>
            </h2>
          </div>
        </div>
        <div className="grid semi:grid-cols-2 semi:ml-12 sm:mx-4">
          <div className="col-span-1">
            <DatosDelVehiculo
              vehicleDetails={driverDetails ? driverDetails : null}
            />
          </div>
          <div className="col-span-1 text-center">
            <TablaDocumentos
              vehicleDetails={driverDetails ? driverDetails : null}
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}
